module.exports = __webpack_public_path__ + "static/media/Muze-logo.6de47676.svg";